export class SocialRegisterModel {
    public token: string;
    public firstName: string;
    public lastName: string;
    public email: string;
    public phone?: string | null | undefined;
    public pictureUrl?: string | null | undefined;
    public languageId: null | number;
}
